module.exports = require('./internal/FixedDataTableRoot');



//////////////////
// WEBPACK FOOTER
// ./node_modules/fixed-data-table-2/main.js
// module id = 830
// module chunks = 0